import "/var/www/html/wp-realoptions/wp-content/themes/realoptions/resources/assets/scripts/autoload/_bootstrap.js";